<div class="app-component-container" id="about-us">
    <div class="content">
        <app-s-header  [elemIds]="elementSignals['component-header']()"></app-s-header>
    </div>

    @if (!isSmallScreen$()){
    <div class="grid-container">
        <mat-grid-list cols="2" [rowHeight]="rowHeight" [gutterSize]="'3rem'">
            @for (elemIds of groupElementSignals['comp-image-text'](); let index = $index; track $index; let e = $even) {
                <mat-grid-tile>
                    <app-base-two-column-text-image [elementIds]="elemIds" [showElement]="e ? 'text' : 'image'"></app-base-two-column-text-image>
                </mat-grid-tile>

                <mat-grid-tile>
                    <app-base-two-column-text-image [elementIds]="elemIds" [showElement]="e ? 'image' : 'text'"></app-base-two-column-text-image>
                </mat-grid-tile>
            }
        </mat-grid-list>
    </div>
    }
    @else {
    <swiper-container style="--swiper-navigation-color: #ddc8c8; --swiper-pagination-color: #fff" pagination="true"
        pagination-clickable="true" navigation="true" centered-slides="true">

        @for (elemIds of groupElementSignals['comp-image-text'](); let index = $index; track $index) {
            <swiper-slide>
                <div class="slide-content">
                    <app-base-two-column-text-image [elementIds]="elemIds" [showElement]="'both'"></app-base-two-column-text-image>
                </div>
            </swiper-slide>
            }
    </swiper-container>
    }
</div>